/**
 * UserAvatar — the 2.5a `Avatar` with its Phase 2.5b photo seam fed.
 *
 * The component IS the wiring: `Avatar` already owns the shape, the hue, the
 * initials and the "a failed photo falls back to initials" contract; this
 * wrapper adds exactly one thing — a `src` resolved from `GET /users/:id/avatar`
 * through `useAvatarUrl`. It exists as a component (rather than call sites
 * invoking the hook themselves) because most sites render avatars inside
 * `rows.map(...)`, where a hook cannot be called.
 *
 * `src` is deliberately not accepted from outside: a caller with its own URL
 * (the profile menu's local preview) uses `Avatar` directly, and a caller with
 * a user id uses this. One prop source per component keeps "where did this
 * photo come from" a non-question.
 */

import { Avatar } from '../../components/ui';
import type { AvatarProps } from '../../components/ui';
import { useAvatarUrl } from './use-avatar';

export type UserAvatarProps = Omit<AvatarProps, 'src'>;

export function UserAvatar(props: UserAvatarProps): React.JSX.Element {
  const src = useAvatarUrl(props.userId);
  return <Avatar {...props} src={src} />;
}
